export const NAME_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù' ]*$/;
export const MOBILE_PATTERN = /^([+]\d{2}\s*)?\d{9,10}$/;
export const VAT_NUMBER_PATTERN = /^[0-9A-Za-z]{3}[0-9]{5,9}$/;
export const POD_PATTERN = /^IT\d{3}E\d{8}\d?$/;
export const PRODUCTION_POD_PATTERN = /^ITP\d[A-Z]E\d{8}\d?$/;
export const IBAN_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/;
export const FISCAL_CODE_PATTERN = /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/;
export const PROVIDER_PATTERN = /^[a-zA-Z0-9ÀÈÌÒÙàèìòù'& /-]*$/;
export const EMAIL_PATTERN = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,4}$/;
